import type { NextPage } from 'next';
import React from 'react';
import { useIntl } from 'react-intl';

import FullRvImage from '@/assets/group-rv-bookings/airstream-open-door-chairs.jpg';
import TrainHeroImage from '@/assets/group-rv-bookings/airstreams-forest-campsite.jpg';
import SmallWeddingImage from '@/assets/group-rv-bookings/wedding-couple-forest-aisle.jpg';
import WeddingHeroImage from '@/assets/group-rv-bookings/wedding-couple-forest-aisle.jpg';
import { GroupRvEnquiryForm } from '@/components/route/group-rv-bookings/EnquiryForm';
import { GroupRvFaqs } from '@/components/route/group-rv-bookings/FAQs';
import { GroupRvHero } from '@/components/route/group-rv-bookings/Hero';
import { GroupRvHowItWorks } from '@/components/route/group-rv-bookings/HowItWorks';
import { GroupRvTestimonial } from '@/components/route/group-rv-bookings/Testimonial';
import {
  DEFAULT_WHY_RV_CARDS,
  GroupRvWhyRVs,
  SOCCER_CARD,
} from '@/components/route/group-rv-bookings/WhyRVs';
import HeadMeta from '@/components/static-pages/HeadMeta';

const GroupRvWeddingsPage: NextPage = () => {
  const intl = useIntl();

  // Reuse the same SEO copy as the main group bookings page for now.
  const title = intl.formatMessage({
    id: 'tClkXo',
    defaultMessage: 'Group RV Rentals for weddings has never been easier.',
    description: 'Group bookings landing page SEO title',
  });

  const description = intl.formatMessage({
    id: '1J1XoP',
    defaultMessage:
      "Need 5+ RVs for guest stays and bridal suites on site? We're your dedicated, stress-free concierge service.",
    description: 'Group bookings landing page SEO description',
  });

  return (
    <>
      <HeadMeta title={title} description={description} />

      <main>
        {/* Hero */}
        <GroupRvHero
          eyebrow="Booking multiple RVs made easy."
          headline="Group RV Rentals for weddings has never been easier."
          body={
            <>
              Need 5+ RVs for guest stays and bridal suites on site?
              <br />
              We&apos;re your dedicated, stress-free concierge service.
            </>
          }
          images={[WeddingHeroImage, TrainHeroImage]}
        />

        {/* How it works */}
        <GroupRvHowItWorks />

        {/* Enquiry form (scroll target for CTAs above) */}
        <GroupRvEnquiryForm page="weddings" />

        {/* Testimonial */}
        <GroupRvTestimonial
          templateType="SubPage"
          subPageKey="wedding-coordinator"
          subPageImages={{ primary: FullRvImage, secondary: SmallWeddingImage }}
        />

        {/* FAQs */}
        <GroupRvFaqs />

        {/* Why RVs section */}
        <GroupRvWhyRVs
          color={true}
          heading="Interested in booking RVs for other types of events? "
          cards={[SOCCER_CARD, ...DEFAULT_WHY_RV_CARDS.filter(card => card.key !== 'weddings')]}
        />
      </main>
    </>
  );
};

export default GroupRvWeddingsPage;
